import 'css-chunksrc/client/scenes/projectCreationForm/tagList/tag/styles.scss';export default {
  "tag": "_tag_289i6_1",
  "icon": "_icon_289i6_26",
  "removeTagIconContainer": "_removeTagIconContainer_289i6_38"
};